<template>
  <div class="about-us-our-careers bg--color-01">
    <div class="container-wrapper bg--color-10">
      <div class="about-us-our-careers__container container-new">
        <div class="about-us-our-careers__image">
          <img :src="require('@/assets/img/about-us/career/main-image.svg')">
        </div>

        <div class="about-us-our-careers__content flx flx--col">
          <span class="txt txt--36px txt--height-44px txt--52px--m txt--height-64px--m txt--color-04 txt--bold">
            {{ $t('aboutUs.ourCareers.title') }}
          </span>

          <span class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-04 pt-8">
            {{ $t('aboutUs.ourCareers.description') }}
          </span>

          <exc-button
            soon
            class="about-us-our-careers__btn mt-20 mt-32--m"
          >
            {{ $t('aboutUs.ourCareers.btnText') }}
          </exc-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcButton } from '@/components/common'

export default {
  components: { ExcButton },
}
</script>

<style lang="scss" scoped>
.about-us-our-careers {
  &__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(22px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
      align-items: center;
      gap: toRem(32px);
    }
  }

  &__btn {
    max-width: fit-content;
  }

  &__image {
    img {
      max-width: toRem(218px);
    }

    @include bp(m) {
      text-align: center;

      img {
        max-width: 100%;
      }
    }
  }
}
</style>
